import React from "react";
import Visualization from "./Visualization";
import TableComponent from "./TableComponent";
const Datavisualization = () => {
  return (
    <div className="container">
      <Visualization />
      <TableComponent />
    </div>
  );
};

export default Datavisualization;
